import React, { useState, useEffect } from "react"
import { useHistory } from "react-router"
// import backImage from "../../assets/images/back-icon.svg"

import { useSelector } from "react-redux"
import Select from "react-select"
import moment from "moment"
import { getChemoPendingRasieRequests, getChemoApprovalsList } from "core/services/api/mrdService"
import "./PendingChemoApproval.scss"
import Button from "components/Button"
import { MocUserRole } from "../../../../core/services/models/Enums"

function PendingChemoApproval() {
    const history = useHistory()
    const userRole = useSelector((state: any) => state?.user?.role)

    const [pendingApprovalRaiseRequests, setPendingApprovalRaiseRequests] = useState<any>([])
    const [sortByTime, updateSortBy] = useState("DESC");
    const [data, setData] = useState<string[]>([]);
    //Pagination
    const [pages, setPages] = useState<any>(0)
    const [currPage, setCurrPage] = useState<any>(0)
    const [pageSize, setPageSize] = useState<any>(10)
    //Search For Patient Directory
    const [searchText, setSearchText] = useState<any>("")
    const chemoptions = [
        { value: '', label: 'All' },
        { value: 'PENDING', label: 'Pending' },
        { value: 'APPROVED', label: 'Approved' },
        { value: 'REJECTED', label: 'Rejected' }
    ];
    const [filterOption, setFilterOption] = useState<any>(chemoptions[0].value)

    useEffect(() => {
        setCurrPage(0)
    }, [filterOption])

    useEffect(() => {
        //Pending Chemo Approval Requests for Approval API

        if (userRole === MocUserRole?.CONSULTANT) {
            let url = ""
            if (searchText) {
                url = `chemo-order/pending-approvals-pagination?page=${currPage}&pageSize=${pageSize}&searchText=${searchText}&approvalStatus=${filterOption}`
            } else {
                url = `chemo-order/pending-approvals-pagination?page=${currPage}&pageSize=${pageSize}&approvalStatus=${filterOption}`
            }
            if (sortByTime) {
                url += `&sortBy=chemoOrderForDate&sortDirection=${sortByTime}`
            }

            getChemoPendingRasieRequests(url)
                .then((res: any) => {
                    console.log("resposnde from pending", res)
                    const { data, totalPages } = res
                    setPages(totalPages)
                    setData(data)
                    setPendingApprovalRaiseRequests(data)

                })
                .catch((err: any) => console.log(err?.message))
        } else {
            let url = ""
            if (searchText) {
                url = `chemo-order/pending-requests-pagination?page=${currPage}&pageSize=${pageSize}&searchText=${searchText}&approvalStatus=${filterOption}`
            } else {
                url = `chemo-order/pending-requests-pagination?page=${currPage}&pageSize=${pageSize}&approvalStatus=${filterOption}`
            }
            if (sortByTime) {
                url += `&sortBy=chemoOrderForDate&sortDirection=${sortByTime}`
            }

            getChemoApprovalsList(url)
                .then((res: any) => {
                    console.log("response from chemo approval request", res)
                    console.log("resposnde from pending", res)
                    const { data, totalPages } = res
                    setPages(totalPages)
                    setData(data)
                    setPendingApprovalRaiseRequests(data)
                })
                .catch((err: any) => console.log(err?.message))
        }

    }, [pageSize, currPage, searchText, sortByTime, filterOption])

    useEffect(() => {
        if (sortByTime) {
            const temp = [...pendingApprovalRaiseRequests]
            temp?.sort((a: any, b: any) => {
                return sortByTime === "asc" ?
                    a?.startedDateTime > b?.startedDateTime ? 1 : -1
                    : a?.startedDateTime < b?.startedDateTime ? 1 : -1
            })
            setPendingApprovalRaiseRequests(temp)
        }
    }, [sortByTime])

    const handleSortOption = (e: any) => {
        updateSortBy(sortByTime === "ASC" ? "DESC" : "ASC")
    }

    const handleViewAll = async (item: any) => {
        history.push({
            pathname: "/chemoApprovalRequest",
            state: {
                id: item?.id
            },
        })
    }




    return (
        <div className="chemo-approval-request-wrapper">
            <div className="chemo-approval-request-section">
                <section className="section-two-container">
                    <div className="search-dropdown-wrapper">
                        <div className="row pl-42 pt-17px">
                            <div className="col-md-5 col-lg-5">
                                <span>
                                    <input
                                        className="inputGlobalSearch"
                                        placeholder="Search"
                                        onChange={(e) => {
                                            setSearchText(e.target.value)
                                            setCurrPage(0);
                                        }}
                                    />
                                    <img
                                        src="assets/images/searchIcon.svg"
                                        alt=""
                                        style={{
                                            marginLeft: "-50px",
                                            width: "26px",
                                            height: "26px",
                                        }}
                                    />
                                </span>
                            </div>
                            <div className="col-md-1 col-lg-1">
                                <Select
                                    styles={{
                                        control: (provided, state) => ({
                                            ...provided,
                                            border: "1px solid #ccd0e7",
                                            borderRadius: "10px"
                                        })
                                    }}
                                    options={chemoptions}
                                    value={chemoptions.find(option => option.value === filterOption)}
                                    onChange={(option: any) => {
                                        setFilterOption(option?.value)
                                    }}
                                />
                            </div>
                            <div className="col-md-1 col-lg-1">

                                <Button
                                    text="Sort By Time"
                                    outline={true}
                                    onClick={handleSortOption}
                                    id="sort-by-time"
                                />
                            </div>
                        </div>
                    </div>
                    {pendingApprovalRaiseRequests?.map((item: any) => {
                        return (
                            <div className="pending-appointment-request-wrapper">
                                <div className="row patientid">
                                    <div className="col-md-1 col-lg-1">
                                        <label className="patient-id-container">Patient ID:</label>
                                    </div>
                                    <div className="col-md-2 col-lg-2 p-0 patientidvalue">
                                        {item?.patientMocId}
                                    </div>
                                    <div className="col-md-9 col-lg-9 editSection">
                                        <div style={{ paddingLeft: "20px" }}>
                                            {
                                                userRole === MocUserRole.CONSULTANT ? (
                                                    <img
                                                        src={"../../../assets/images/CRedit.svg"}
                                                        alt="edit"
                                                        width={24}
                                                        height={24}
                                                        onClick={() =>
                                                            handleViewAll(item)
                                                        }
                                                    />
                                                ) : (
                                                    <img
                                                        src={"../../../assets/images/eyeIcon.svg"}
                                                        className="cursor-pointer"
                                                        alt="edit"
                                                        width={24}
                                                        height={24}
                                                        onClick={() =>
                                                            handleViewAll(item)
                                                        }
                                                    />
                                                )
                                            }

                                        </div>
                                    </div>
                                </div>

                                <div className="row pt-28 patientdetails">
                                    <div className="col-12 d-flex">
                                        <div className="col-4 pl-47 sectionone">
                                            <div className="row">
                                                <div className="col-12 d-flex pt-24">
                                                    <div className="col-4">
                                                        <label className="patient-id-container">
                                                            Patient name:
                                                        </label>
                                                    </div>
                                                    <div className="col-8">
                                                        <label className="values-container-field">
                                                            &nbsp;{item?.patientName}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-12 d-flex">
                                                    <div className="col-4">
                                                        <label className="patient-id-container">
                                                            Consultant Name:
                                                        </label>
                                                    </div>
                                                    <div className="col-8">
                                                        <label className="values-container-field">
                                                            {item?.consultantName}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-4 pl-47 sectiontwo">
                                            <div className="row">
                                                <div className="col-12 d-flex">
                                                    <div className="col-4">
                                                        <label className="patient-id-container">
                                                            Date:
                                                        </label>
                                                    </div>
                                                    <div className="col-8">
                                                        <label className="values-container-field">
                                                            {item?.chemoOrderForDate
                                                                ? moment(item?.chemoOrderForDate).format(
                                                                    "DD-MM-yyyy"
                                                                )
                                                                : ""}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-12 d-flex">
                                                    <div className="col-4">
                                                        <label className="patient-id-container">
                                                            Start Time:
                                                        </label>
                                                    </div>
                                                    <div className="col-8">
                                                        <label className="values-container-field">
                                                            {item?.startedDateTime
                                                                ? moment(item?.startedDateTime).format("HH:mm:ss a")
                                                                : ""}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-12 d-flex">
                                                    <div className="col-4">
                                                        <label className="patient-id-container">
                                                            Completed Time:
                                                        </label>
                                                    </div>


                                                    <div className="col-8">
                                                        <label className="values-container-field">
                                                            {item?.completedDateTime
                                                                ? moment(item?.completedDateTime).format("HH:mm:ss a")
                                                                : ""}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-4 pl-47 sectionthree">
                                            <div className="row">
                                                <div className="col-12 d-flex">
                                                    <div className="col-4">
                                                        <label className="patient-id-container">
                                                            Contact Number:
                                                        </label>
                                                    </div>

                                                    <div className="col-8">
                                                        <label className="values-container-field">
                                                            {item?.patientPhoneNumber}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-12 d-flex">
                                                    <div className="col-4">
                                                        <label className="patient-id-container">
                                                            Email:
                                                        </label>
                                                    </div>

                                                    <div className="col-8">
                                                        <label className="values-container-field">
                                                            {item?.patientEmail}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row complaintsection">
                                    <div className="col-3">
                                        <label className="patient-id-container">Chemo Order Status:</label>
                                    </div>
                                    <div className="col-9 complaintreason">
                                        <label className="values-container-field">
                                            {item?.isActive ? "ACTIVE" : item?.isCompleted ? "COMPLETED" : ""}
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label className="patient-id-container">Line of Treatment:</label>
                                    </div>
                                    <div className="col-9 complaintreason">
                                        <label className="values-container-field">
                                            {item?.lineOfTreatment}
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label className="patient-id-container">Next Cycle On:</label>
                                    </div>
                                    <div className="col-9 complaintreason">
                                        <label className="values-container-field">
                                            {item?.nextCycleOn
                                                ? moment(item?.nextCycleOn).format(
                                                    "DD-MM-yyyy"
                                                )
                                                : ""}
                                        </label>
                                    </div>
                                </div>
                                <div className="row statussection">
                                    <div className="col-3">
                                        <div className="row">
                                            <label className="patient-id-container">Status:</label>
                                        </div>
                                    </div>
                                    <div className="col-9 statusdetails">
                                        <div className="row">
                                            <label className="values-container-field">{item?.status}</label>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="row">
                                            <label className="patient-id-container">Comment:</label>
                                        </div>
                                    </div>
                                    <div className="col-9 statusdetails">
                                        <div className="row">
                                            <label className="values-container-field">{item?.comment ? item?.comment : ""}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </section>
            </div>

            {/* Pagination */}
            {
                data && data?.length > 0 ? (

                    <div
                        style={{ marginTop: "20px" }} className="pagination-footer"
                    >

                        <button
                            className="pagination-button"
                            onClick={() => {
                                setCurrPage(0);
                            }}
                            disabled={currPage === 0}
                        >
                            {"First"}
                        </button>
                        <button
                            className="pagination-button"
                            onClick={() => {
                                setCurrPage(currPage - 1);
                            }}
                            disabled={currPage === 0}
                        >
                            {"Previous"}
                        </button>
                        <span className="pagination-text">
                            Page{" "}
                            <strong>
                                {currPage + 1} of {pages}
                            </strong>
                        </span>
                        <button
                            className="pagination-button"
                            onClick={() => {
                                setCurrPage(currPage + 1);
                            }}
                            disabled={currPage === pages - 1}
                        >
                            {"Next"}
                        </button>
                        <button
                            className="pagination-button"
                            onClick={() => {
                                setCurrPage(pages - 1);
                            }}
                            disabled={currPage === pages - 1}
                        >
                            {"Last"}
                        </button>
                        <select
                            className="pagination-select"
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                                setCurrPage(0);
                            }}
                        >
                            {[10, 15, 20, 25, 50].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                </option>
                            ))}
                        </select>
                    </div>
                ) : null
            }
        </div>
    )
}

export default PendingChemoApproval
